import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M 3.5 9.5 H 16.5 V 10.5 H 3.5 V 9.5 Z'],
  height: 20,
  width: 20,
});
